exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".folyamat-sav-item[data-v-4a3aa412]{cursor:pointer;font-size:16px;font-weight:700}.folyamat-sav-link-parent[data-v-4a3aa412]:hover{background-color:#edefeb;cursor:pointer}.check-mark[data-v-4a3aa412]{float:right}", ""]);

// exports
